module.exports = __webpack_public_path__ + "img/電気回路_6_6_3.8564585e.png";